//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 导入plupload包
import plupload from 'plupload'
import * as $ from 'jquery'
// console.log($);
var fileArr = [];
export default {
  name: "uploadoss",
  data() {
    return {
      // 将不需要显示的控件隐藏
      flag:false,
      obj: {},
      uploadPercent: 0,
      // 保存页面需要渲染的文件数据
      // ossurldata:[],
    }
  },
  props: [ 'title', 'url' ],
  methods: {
    getsign () {
      var that = this
      if(that.url == 'userChannel/upload' || that.url == 'quotation/uploadImage'){
        this.$request.post('/'+this.url,{})
        .then((response) => {
          // console.log('加工方式',response);
          // console.log(this);//vm
          console.log(response);
          this.$emit('reFlag',true);
          if (response.code == 0) {
            that.obj = response.obj
            // console.log(obj);
            // this.processdata = _result;
          }
          else {
            return;
          }
        })
      
        $('.moxie-shim-html5').remove();
        var accessid = ''
        var accesskey = ''
        var host = ''
        var policyBase64 = ''
        var signature = ''
        var callbackbody = ''
        var filename = ''
        var key = ''
        var expire = 0
        var g_object_name = ''
        var g_object_name_type = ''
        var timestamp = Date.parse(new Date()) / 1000;
        var now = timestamp;

        function check_object_radio() {
          var tt = document.getElementsByName('myradio');
          for (var i = 0; i < tt.length; i++) {
            if (tt[i].checked) {
              g_object_name_type = tt[i].value;
              break;
            }
          }
        }

        function get_signature() {
          // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
          now = timestamp = Date.parse(new Date()) / 1000;
          if (expire < now + 3) {

            host = that.obj['host']
            // console.log(host);
            policyBase64 = that.obj['policy']
            accessid = that.obj['accessid']
            signature = that.obj['signature']
            expire = parseInt(that.obj['expire'])
            callbackbody = that.obj['callback']
            key = that.obj['dir']
            // console.log(key);

            return true;
          }
          return false;
        };

        function random_string(len) {
          len = len || 32;
          var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
          var maxPos = chars.length;
          var pwd = '';
          for (let i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
          }
          return pwd;
        }

        function get_suffix(filename) {
          let pos = filename.lastIndexOf('.')
          let suffix = ''
          if (pos != -1) {
            suffix = filename.substring(pos)
          }
          return suffix;
        }

        function calculate_object_name(filename) {
          if (g_object_name_type == 'local_name') {
            g_object_name += "${filename}"
          }
          else if (g_object_name_type == 'random_name') {
            let suffix = get_suffix(filename)
            g_object_name = key + random_string(10) + suffix
          }
          return ''
        }

        function get_uploaded_object_name(filename) {
          if (g_object_name_type == 'local_name') {
            let tmp_name = g_object_name
            tmp_name = tmp_name.replace("${filename}", filename);
            return tmp_name
          }
          else if (g_object_name_type == 'random_name') {
            return g_object_name
          }
        }

        function set_upload_param(up, filename, ret) {
          if (ret == false) {
            ret = get_signature()
          }
          g_object_name = key;
          if (filename != '') {
            let suffix = get_suffix(filename)
            calculate_object_name(filename)
          }
          let new_multipart_params = {
            'key': g_object_name,
            'policy': policyBase64,
            'OSSAccessKeyId': accessid,
            'success_action_status': '200', //让服务端返回200,不然，默认会返回204
            // 'callback' : callbackbody,
            'signature': signature,
          };

          up.setOption({
            'url': host,
            'multipart_params': new_multipart_params
          });

          up.start();
        }

        // console.log(this);//vm
        var uploader = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: 'selectfiles',
          multi_selection: false,
          container: document.getElementById('container'),
          flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
          silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',

          filters: {
            mime_types: [ //只允许上传图片和zip文件和stl文件
              // {title: "Image files", extensions: "jpg,gif,png,bmp"},
              // {title: "Zip files", extensions: "zip,rar"},
              // {title: "THREE files", extensions: "stl"}
            ],
            max_file_size: '100mb', //最大只能上传100mb的文件
            prevent_duplicates: true//是否允许选取重复文件
          },

          max_retries: 3, //请求错误时的重试次数，为0时表示不重试

          init: {
            PostInit:()=> {
              // console.log(this);
              // console.log('第一步,按钮被点击,获取oss密钥,并出现文件选择窗口');
              // console.log(obj);
              document.getElementById('ossfile').innerHTML = '';
              // document.getElementById('postfiles').onclick = function () {
              //   set_upload_param(uploader, '', false);
              //   return false;
              // };
            },

            FilesAdded:  (up, files)=> {
              if(that.title == 'imgType'){
                if(files[0].name.split('.')[1] != 'jpeg' && files[0].name.split('.')[1] != 'jpg' && files[0].name.split('.')[1] != 'png') {
                  this.$vux.toast.show({
                    type: 'warn',
                    text: '请上传图片'
                  })
                  return false;
                }
              }
              console.log('第二步,有新文件添加至队列');
              // console.log(this);
              set_upload_param(uploader, '', false);
              // console.log(files);
              //向父组件发送数据
              this.$emit('getossdata',files);
              plupload.each(files,  (file)=> {
                document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b>'
                  + '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                  + '</div>';
              });
            },

            BeforeUpload: function (up, file) {
              console.log('第三步,上传前准备');
              check_object_radio();
              set_upload_param(up, file.name, true);

              console.log('11111111111111111111111')
            },

            UploadProgress:  (up, file)=> {
              console.log('第四步,上传中...');

              this.$emit('getprogressbar',file.id,file.percent)
              // console.log(file);
              var d = document.getElementById(file.id);
              d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
              var prog = d.getElementsByTagName('div')[0];
              // progBar是上传进度
              var progBar = prog.getElementsByTagName('div')[0]
              // console.log(file.percent);
              progBar.style.width = 2 * file.percent + 'px';
              progBar.setAttribute('aria-valuenow', file.percent);
              // console.log(this.ossdata);
            },

            FileUploaded:  (up, file, info) =>{
              console.log('第五步,上传结束后,获取oss路径,并在ossurl中添加当前上传的对象');
              if (info.status == 200) {
                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = 'upload to oss success, object name:' + get_uploaded_object_name(file.name) + ' 回调服务器返回的内容是:' + JSON.stringify(info);

                // 获取上传后文件的id
                var igsCanvasId = file.id;
                // console.log(host,key,get_uploaded_object_name(file.name));
                // 获取上传后文件的路径
                var ossPath = host + '/' + get_uploaded_object_name(file.name);

                  var obj = {};
                  obj.fileName = file.name;
                  obj.path = host + '/' + get_uploaded_object_name(file.name);
                  // obj.path = host + '/' + response.obj.dir + get_uploaded_object_name(file.name);
                  obj.imgUrl = ossPath
                  if(uploader.multi_selection){
                    fileArr.push(obj)
                  }else{
                    // if(this.url == 'userChannel/upload'){
                    //   fileArr.push(obj)
                    // }else{
                      fileArr.splice(0,1,obj)
                    // }
                  }
                //将路径添加到
                this.$emit('getossurl',fileArr);

                // this.ossurldata.push(ossPath);
              }
              else if (info.status == 203) {
                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '上传到OSS成功，但是oss访问用户设置的上传回调服务器失败，失败原因是:' + info.response;
              }
              else {
                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
              }
            },

            Error: function (up, err) {
              console.log('出现错误');
              if (err.code == -600) {
                document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"));
              }
              else if (err.code == -601) {
                document.getElementById('console').appendChild(document.createTextNode("\n选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型"));
              }
              else if (err.code == -602) {
                document.getElementById('console').appendChild(document.createTextNode("\n这个文件已经上传过一遍了"));
              }
              else {
                document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
              }
            }
          }
        });
        uploader.init();
      }else{
        this.$request.post('/'+this.url,{})
          .then((response) => {
            // console.log('加工方式',response);
            // console.log(this);//vm
            console.log(response);
            this.$emit('reFlag',true);
            if (response.code == 0) {
              $('.moxie-shim-html5').remove();
              var obj = response.obj
              // console.log(obj);
              // this.processdata = _result;
              var accessid = ''
              var accesskey = ''
              var host = ''
              var policyBase64 = ''
              var signature = ''
              var callbackbody = ''
              var filename = ''
              var key = ''
              var expire = 0
              var g_object_name = ''
              var g_object_name_type = ''
              var timestamp = Date.parse(new Date()) / 1000;
              var now = timestamp;

              // function send_request()
              // {
              //   var xmlhttp = null;
              //   if (window.XMLHttpRequest)
              //   {
              //     xmlhttp=new XMLHttpRequest();
              //   }
              //   else if (window.ActiveXObject)
              //   {
              //     xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
              //   }
              //
              //   if (xmlhttp!=null)
              //   {
              //     // serverUrl是 用户获取 '签名和Policy' 等信息的应用服务器的URL，请将下面的IP和Port配置为您自己的真实信息。
              //     serverUrl = 'http://192.168.181.57:8081/website/quotation/upload'
              //
              //     xmlhttp.open( "post", serverUrl,false);
              //     xmlhttp.setRequestHeader("Content-type","application/json")
              //     xmlhttp.send(JSON.stringify({}));
              //     return xmlhttp.responseText
              //   }
              //   else
              //   {
              //     alert("Your browser does not support XMLHTTP.");
              //   }
              // };
              // console.log(send_request);
              function check_object_radio() {
                var tt = document.getElementsByName('myradio');
                for (var i = 0; i < tt.length; i++) {
                  if (tt[i].checked) {
                    g_object_name_type = tt[i].value;
                    break;
                  }
                }
              }

              function get_signature() {
                // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
                now = timestamp = Date.parse(new Date()) / 1000;
                if (expire < now + 3) {
                  // body = send_request()
                  // console.log(body);
                  // var obj = eval ("(" + body + ")").obj;
                  // console.log(obj);

                  host = obj['host']
                  // console.log(host);
                  policyBase64 = obj['policy']
                  accessid = obj['accessid']
                  signature = obj['signature']
                  expire = parseInt(obj['expire'])
                  callbackbody = obj['callback']
                  key = obj['dir']
                  // console.log(key);

                  return true;
                }
                return false;
              };

              function random_string(len) {
                len = len || 32;
                var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                var maxPos = chars.length;
                var pwd = '';
                for (let i = 0; i < len; i++) {
                  pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
              }

              function get_suffix(filename) {
                let pos = filename.lastIndexOf('.')
                let suffix = ''
                if (pos != -1) {
                  suffix = filename.substring(pos)
                }
                return suffix;
              }

              function calculate_object_name(filename) {
                if (g_object_name_type == 'local_name') {
                  g_object_name += "${filename}"
                }
                else if (g_object_name_type == 'random_name') {
                  let suffix = get_suffix(filename)
                  g_object_name = key + random_string(10) + suffix
                }
                return ''
              }

              function get_uploaded_object_name(filename) {
                if (g_object_name_type == 'local_name') {
                  let tmp_name = g_object_name
                  tmp_name = tmp_name.replace("${filename}", filename);
                  return tmp_name
                }
                else if (g_object_name_type == 'random_name') {
                  return g_object_name
                }
              }

              function set_upload_param(up, filename, ret) {
                if (ret == false) {
                  ret = get_signature()
                }
                g_object_name = key;
                if (filename != '') {
                  let suffix = get_suffix(filename)
                  calculate_object_name(filename)
                }
                let new_multipart_params = {
                  'key': g_object_name,
                  'policy': policyBase64,
                  'OSSAccessKeyId': accessid,
                  'success_action_status': '200', //让服务端返回200,不然，默认会返回204
                  // 'callback' : callbackbody,
                  'signature': signature,
                };

                up.setOption({
                  'url': host,
                  'multipart_params': new_multipart_params
                });

                up.start();
              }

              // console.log(this);//vm
              var uploader = new plupload.Uploader({
                runtimes: 'html5,flash,silverlight,html4',
                browse_button: 'selectfiles',
                multi_selection: false,
                container: document.getElementById('container'),
                flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                url: 'http://oss.aliyuncs.com',

                filters: {
                  mime_types: [ //只允许上传图片和zip文件和stl文件
                    // {title: "Image files", extensions: "jpg,gif,png,bmp"},
                    // {title: "Zip files", extensions: "zip,rar"},
                    // {title: "THREE files", extensions: "stl"}
                  ],
                  max_file_size: '100mb', //最大只能上传100mb的文件
                  prevent_duplicates: true//是否允许选取重复文件
                },

                max_retries: 3, //请求错误时的重试次数，为0时表示不重试

                init: {
                  // PostInit: function () {
                  //   console.log(this);
                  //   console.log('第一步,按钮被点击,出现文件选择窗口');
                  //   document.getElementById('ossfile').innerHTML = '';
                  //   document.getElementById('postfiles').onclick = function () {
                  //     // console.log('2222222222');
                  //     set_upload_param(uploader, '', false);
                  //     return false;
                  //   };
                  // },
                  PostInit:()=> {
                    // console.log(this);
                    // console.log('第一步,按钮被点击,获取oss密钥,并出现文件选择窗口');
                    // console.log(obj);
                    document.getElementById('ossfile').innerHTML = '';
                    // document.getElementById('postfiles').onclick = function () {
                    //   set_upload_param(uploader, '', false);
                    //   return false;
                    // };
                  },

                  FilesAdded:  (up, files)=> {
                    console.log('第二步,有新文件添加至队列');
                    // console.log(this);
                    set_upload_param(uploader, '', false);
                    // console.log(files);
                    //向父组件发送数据
                    this.$emit('getossdata',files);
                    plupload.each(files,  (file)=> {
                      document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b>'
                        + '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                        + '</div>';
                    });
                    this.uploadPercent = 0
                    that.$vux.loading.show({
                      text: '上传中 '+that.uploadPercent+'%'
                    })
                  },

                  BeforeUpload: function (up, file) {
                    console.log('第三步,上传前准备');
                    check_object_radio();
                    set_upload_param(up, file.name, true);

                    console.log('11111111111111111111111')
                  },

                  UploadProgress:  (up, file)=> {
                    console.log('第四步,上传中...');
                    that.$vux.loading.show({
                      text: '上传中 '+that.uploadPercent+'%'
                    })
                    that.uploadPercent = file.percent
                    this.$emit('getprogressbar',file.id,file.percent)
                    // console.log(file);
                    var d = document.getElementById(file.id);
                    d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
                    var prog = d.getElementsByTagName('div')[0];
                    // progBar是上传进度
                    var progBar = prog.getElementsByTagName('div')[0]
                    // console.log(file.percent);
                    progBar.style.width = 2 * file.percent + 'px';
                    progBar.setAttribute('aria-valuenow', file.percent);
                    // console.log(this.ossdata);
                  },

                  FileUploaded:  (up, file, info) =>{
                    console.log('第五步,上传结束后,获取oss路径,并在ossurl中添加当前上传的对象');
                    // console.log(up)
                    // console.log(file)
                    // console.log(info)
                    // console.log(this);
                    // console.log(this.ossurldata);
                    if (info.status == 200) {
                      document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = 'upload to oss success, object name:' + get_uploaded_object_name(file.name) + ' 回调服务器返回的内容是:' + JSON.stringify(info);

                      // 获取上传后文件的id
                      var igsCanvasId = file.id;
                      // console.log(host,key,get_uploaded_object_name(file.name));
                      // 获取上传后文件的路径
                      var ossPath = host + '/' + get_uploaded_object_name(file.name);

                        var obj = {};
                        obj.fileName = file.name;
                        obj.path = host + '/' + get_uploaded_object_name(file.name);
                        // obj.path = host + '/' + response.obj.dir + get_uploaded_object_name(file.name);
                        obj.imgUrl = ossPath
                        if(uploader.multi_selection){
                          fileArr.push(obj)
                        }else{
                          // if(this.url == 'userChannel/upload'){
                          //   fileArr.push(obj)
                          // }else{
                            fileArr.splice(0,1,obj)
                          // }
                        }
                        
                      // console.log(file);
                      // console.log(ossPath);
                      // console.log(igsCanvasId);
                      //将路径添加到
                      this.$emit('getossurl',fileArr);
                      
                      // this.ossurldata.push(ossPath);
                    }
                    else if (info.status == 203) {
                      document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '上传到OSS成功，但是oss访问用户设置的上传回调服务器失败，失败原因是:' + info.response;
                    }
                    else {
                      document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
                    }
                    that.$vux.loading.hide()
                    this.$vux.toast.show({
                      type: 'success',
                      text: '已上传'
                    })
                  },

                  Error: function (up, err) {
                    console.log('出现错误');
                    that.$vux.loading.hide()
                    this.$vux.toast.show({
                      type: 'cancel',
                      text: '上传出错啦'
                    })
                    if (err.code == -600) {
                      document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"));
                    }
                    else if (err.code == -601) {
                      document.getElementById('console').appendChild(document.createTextNode("\n选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型"));
                    }
                    else if (err.code == -602) {
                      document.getElementById('console').appendChild(document.createTextNode("\n这个文件已经上传过一遍了"));
                    }
                    else {
                      document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
                    }
                  }
                }
              });
              // console.log(uploader);

              uploader.init();
            }
            else {
              return;
            }
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/uploadoss.vue